import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import { useSelector } from "react-redux";
import { InlineLoader } from "../../spinner/InlineLoader";
import CloseIcon from "@mui/icons-material/Close";
import { selectLoading } from "../../../Redux/Reducers/uiSlice";

export default function Popup(props) {
  const { id, children, openPopup, setOpenPopup, title, showIcon,isSkeleton } = props;
  const loading = useSelector(selectLoading);
  return (
    <>
  
      <Dialog
        open={openPopup}
        sx={{ 
          height: "100vh",
          ...(title === "Manager Blacklist" && {
            "& .MuiDialog-paper": {
              maxWidth: "1200px !important",
              width: "90vw",
              minWidth: "800px"
            }
          })
        }}
        maxWidth={
          title === "ADD SIGNAL"
            ? "md"
            : title === "Manager Blacklist" || title === "Historical Signals"
            ? "lg"
            : title === "Add Account Details" || title === "Change Password"
            ? "xs"
            : "sm"
        }
        onClose={() => setOpenPopup(false)}
      >
        {loading && !isSkeleton && (
          <Box 
            sx={{ 
              position: 'absolute', 
              top: '50%', 
              left: '50%', 
              transform: 'translate(-50%, -50%)',
              zIndex: 1000
            }}
          >
            <InlineLoader message="Loading..." />
          </Box>
        )}
        {title === "Trade Entry Form" ? (
          <DialogTitle
            sx={{
              height: "20px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h6"
              component="div"
              style={{ marginTop: "-11px", fontSize: "18px" }}
            >
              {title}
            </Typography>
            <IconButton
              sx={{ marginTop: "-13px", width: "25px", height: "25px" }}
              onClick={() => {
                setOpenPopup(false);
              }}
            >
              <CloseIcon sx={{ height: "20px", width: "20px" }} />
            </IconButton>
          </DialogTitle>
        ) : !showIcon && title ? (
          title === "Change Password" ? (
            <></>
          ) : (
            <DialogTitle>
            <div style={{ display: "flex" }}>
              <Typography
                variant="h6"
                component="div"
                style={{ flexGrow: 1, fontSize: "20px" }}
              >
                {title}
              </Typography>
              <IconButton
                onClick={() => {
                  setOpenPopup(false);
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
          )
          
        ) : (
          <></>
        )}
        <DialogContent dividers sx={{ padding: title === "Change Password" ? "0px" : "auto" }}>{children}</DialogContent>
      </Dialog>
    </>
  );
}